module.exports = __webpack_public_path__ + "8f891d5458a7d97340a3808fc7074f6b.pdf";